import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import styles from "../../../assets/stylesheets/sass/CustomerFiles.module.scss";
import download_icon_gray from "../../../assets/icons/download_icon_gray.svg";
import download_icon_white from "../../../assets/icons/download_icon_white.svg";
import pdf_icon from "../../../assets/icons/pdf_icon.svg";
import backarrow_icon_white from "../../../assets/icons/backarrow_icon_white.svg";
import arrow_files_title from "../../../assets/icons/arrow_files_title.svg";
import localforage from "localforage";
import { Document, Page, pdfjs   } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";

import { getFitDocToken } from "../../../functions/token";
import { ReactSession }  from 'react-client-session';
import { getUserSettings } from "../../../functions/fetch";
import LoadingStatus from "../../customComponents/LoadingStatus";
import LoadingContainer from "../../customComponents/LoadingContainer";
// import Qastan from "@qastanfit/logger"
import { useSelector } from "react-redux";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
let docs_fast = [];
let waitGetDossier = true;
export default function File(){
    const doctypeTranslations = useSelector(state => state.doctypesTranslations);
    const [content_state, setcontent_state] = useState({});
    useEffect(()=>{
        fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
            res => res.json()
        ).then(
            json => setcontent_state(json)
        )
    }, [])

    const alldoctypes = useSelector(state => state.doctypes)
    
    const navigate = useNavigate();
    let params = useParams();

    const [viewPreview, setviewPreview] = useState(false);
    const [documents, setdocuments] = useState([]);
    const [NotFound, setNotFound] = useState(false);

    const downloadButton = useRef(null);
    const [file_base64, setfile_base64] = useState("");
    const [file_docid, setfile_docid] = useState("");

    
    const saveData = (docs, docid, dosid) =>{
        const setCache = async () =>{
            let tmp_docs = await localforage.getItem("documents"); 

            if(!tmp_docs){
                tmp_docs = [{}]
            }

            if(!tmp_docs[0][dosid]){
                tmp_docs[0][dosid] = []
            }

            setdocuments(docs_fast);

            tmp_docs[0][dosid] = docs_fast
            localforage.setItem("documents", tmp_docs);   
        }
        
        setCache();
    }

    const [docs, setdocs] = useState([]);
    const [fullDoctypes, setfullDoctypes] = useState({});
    const [dossierTitle, setdossierTitle] = useState("");

    useEffect(()=>{
        let title = params.file.split("_");
        let id = title.shift()

        if(title.reverse()[0] === ""){
            setdossierTitle(title[2])
        }
        else{
            setdossierTitle(title.reverse().join(" "))
        }      

        waitGetDossier = true;
        const getData = async () =>{
            const files = await localforage.getItem("dossiers");
            const file_types = await localforage.getItem("dossierTypes");

            let doctypes = alldoctypes;
            
            let fullDocTypes = {}
            if(doctypes){
                for (let j = 0; j < doctypes.length; j++) {
                    fullDocTypes[doctypes[j].doctype] = doctypes[j].docoms[0].oms;
                }
                setfullDoctypes(fullDocTypes);
            }
            

            
            await handleOpenDossier(params.file.split("_")[0], files)
        }
        getData();
        
    }, [params])

    const [tmp_docs, settmp_docs] = useState([]);
    const handleOpenDossier = async (id, files) =>{

        const getDossiers = async () =>{
            let dossier;
            let dossiers = await localforage.getItem("dossiers");
            if(dossiers){
                for (let i = 0; i < dossiers.length; i++) {
                    if(dossiers[i].dossierentityid === parseFloat(id) && waitGetDossier){
                        waitGetDossier = false;
                        dossier = dossiers[i];
                        console.log(dossier)
                        setdocs(dossier.documents);
                    }
                }
            }
            else {
                console.log('fetch dossiers, get documents')
            }
            
            
        }
        getDossiers();
        

        return;
    }
    const [numPages, setNumPages] = useState(null);
    const [loadingfiles, setloadingfiles] = useState({"status":"", "message":""})
    const [showLoading, setshowLoading] = useState(false);

    const handleViewDocument = (e, v) =>{
        setshowLoading(!showLoading);
        setloadingfiles({"status":"loading", "message":"Opening document..."})
        
        //console.log(e.currentTarget.id)
        localforage.getItem("userSettings").then(
            res => {
                if(res){
                    if(typeof(res.json) !== "object" || !res.json ){
                        res.json = {};
                    }

                    if(!res.json.last_opened_files){
                        res.json.last_opened_files = []
                    }

                    let last_opened_files = res.json.last_opened_files;
                    
                    if(last_opened_files.includes(v.document)){
                        const index = last_opened_files.indexOf(v.document);
                        if (index > -1) { 
                            last_opened_files.splice(index, 1);
                        }
                    }

                    if(!last_opened_files.includes((v.document.docid).toString())){
                        last_opened_files = last_opened_files.concat((v.document.docid).toString());
                    }
                    
                    if(last_opened_files.length > 5 && Array.isArray(last_opened_files)){
                        last_opened_files = last_opened_files.slice(1);
                    }

                    res.json.last_opened_files = last_opened_files;

                    localforage.getItem("userSettings").then(
                        us => {
                            if(typeof(res.json) !== "object" || !res.json ){
                            res.json = {};
                        }

                        if(!res.json){ res.json = {}}

                        if(!res.json.last_opened_files){
                            res.json.last_opened_files = []
                        }
                            if(typeof(us.json) !== "object"){us.json = {}}
                            us.json.last_opened_files = last_opened_files;
                            localforage.setItem("userSettings", us);
                        }
                    )

                    //Update object
                    fetch(process.env.REACT_APP_SERVER_LINK+"userSettingsUpdate?token="+window.localStorage.getItem("token")+"&user="+JSON.parse(window.sessionStorage.getItem("user_data")).id, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(res),
                    }).then(
                        res => res.json()
                    ).then(
                        json => {
                            //console.log(json)
                        }
                    )
                }
                else {
                    //fetch user settings
                    let res = getUserSettings(JSON.parse(window.sessionStorage.getItem("user_data")));
                    if(res){
                        if(typeof(res.json) !== "object" || !res.json ){
                            res.json = {};
                        }

                        if(!res.json.last_opened_files){
                            res.json.last_opened_files = []
                        }

                        let last_opened_files = res.json.last_opened_files;
                        
                        if(last_opened_files.includes(v.document.docid)){
                            const index = last_opened_files.indexOf(v.document.docid);
                            if (index > -1) { 
                                last_opened_files.splice(index, 1);
                            }
                        }

                        if(!last_opened_files.includes((v.document.docid).toString())){
                            last_opened_files = last_opened_files.concat((v.document.docid).toString());
                        }
                        
                        if(last_opened_files.length > 5 && Array.isArray(last_opened_files)){
                            last_opened_files = last_opened_files.slice(1);
                        }

                        res.json.last_opened_files = last_opened_files;

                        localforage.getItem("userSettings").then(
                            us => {
                                if(us){
                                    if(typeof(us.json) === "string"){
                                        us.json = {}
                                    }
                                    us.json.last_opened_files = last_opened_files;
                                    localforage.setItem("userSettings", us);
                                }
                                else{
                                    us = {};
                                    us.json = {}
                                    us.json.last_opened_files = last_opened_files;
                                    localforage.setItem("userSettings", us);
                                }
                            }
                        )

                        //Update object
                        fetch(process.env.REACT_APP_SERVER_LINK+"userSettingsUpdate?token="+window.localStorage.getItem("token")+"&user="+JSON.parse(window.sessionStorage.getItem("user_data")).id, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(res),
                        })
                    }
                }
            }
        )

        setfile_base64("");
        setfile_docid("");
        

        fetch(process.env.REACT_APP_SERVER_LINK+"documents?docid="+e.currentTarget.id+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data")))).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    console.log(json);
                    setfile_base64(json.object.file);
                    setfile_docid(json.object.docid.toString())
                    setviewPreview(true)

                    setloadingfiles({"status":"success", "message":"Document opened"})

                    // Qastan.addLog({
                    //     "level":Qastan.level.Info,
                    //     "type":Qastan.type.User_action,
                    //     "details": {
                    //         "title": "File",
                    //         "description": "User opened document " + json.object.file,
                    //         "eventtype": "onopenfile",
                    //     },
                    //     "user": JSON.parse(window.sessionStorage.getItem("user_data")).id
                    // })
                }
                else{
                    setloadingfiles({"status":"failed", "message":"Opening document failed"})

                    // Qastan.addLog({
                    //     "level":Qastan.level.Error,
                    //     "type":Qastan.type.User_action,
                    //     "details": {
                    //         "title": "File",
                    //         "description": "User failed to open document " + json.object.file,
                    //         "eventtype": "onopenfile",
                    //     },
                    //     "user": JSON.parse(window.sessionStorage.getItem("user_data")).id
                    // })
                }
            }
        )
    }

    const setLocaleString = (language) =>{
        if(language === "N"){
            return "nl-BE"
        }
        else if(language === "F"){
            return "fr-FR"
        }
        else{
            return "en-GB"
        }
    }

    const handleDownloadDocument = (e) =>{
        setshowLoading(!showLoading);
        setloadingfiles({"status":"loading", "message":"Downloading document..."})

        fetch(process.env.REACT_APP_SERVER_LINK+"documents?docid="+e.currentTarget.id+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    function downloadPDF(pdf) {
                        const linkSource = `data:application/pdf;base64,${pdf}`;
                        const downloadLink = document.createElement("a");
                        const fileName = `document_${json.object.docid}.pdf`;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();

                        setloadingfiles({"status":"success", "message":"Document downloaded"})

                        // Qastan.addLog({
                        //     "level":Qastan.level.Info,
                        //     "type":Qastan.type.User_action,
                        //     "details": {
                        //         "title": "File",
                        //         "description": "User downloaded document " + e.currentTarget.id,
                        //         "eventtype": "ondownloaddocument",
                        //     },
                        //     "user": JSON.parse(window.sessionStorage.getItem("user_data")).id
                        // })
                    }

                    downloadPDF(json.object.file)
                }
                else{
                    setloadingfiles({"status":"failed", "message":"Document downloading failed"})

                    // Qastan.addLog({
                    //     "level":Qastan.level.Error,
                    //     "type":Qastan.type.User_action,
                    //     "details": {
                    //         "title": "File",
                    //         "description": "User failed downloading document " + e.currentTarget.id,
                    //         "eventtype": "ondownloaddocument",
                    //     },
                    //         "user": JSON.parse(window.sessionStorage.getItem("user_data")).id
                    // })
                }
            }
        )
    }

    const getFullDoctype = (short_type) =>{
        if(fullDoctypes){
            return fullDoctypes[short_type];
        }
        else{
            return short_type;
        }
    }


	return (
	    <>
            {(showLoading || !showLoading) &&
            <LoadingContainer>
                {loadingfiles && <LoadingStatus message={loadingfiles.message} loadingIcon status={loadingfiles.status}/>}
            </LoadingContainer>
            }
            

            {viewPreview && 
                <div className={styles.document_preview}>
                    <div className={styles.document_preview_header}>
                        <button onClick={()=>{setviewPreview(false); setfile_base64("")}}><img src={backarrow_icon_white} alt="icon"/><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Documents && content_state[ReactSession.get("language")].Documents.labelpreview_back && content_state[ReactSession.get("language")].Documents.labelpreview_back) : "Back"}</p></button>
                        <h2 className={styles.document_preview_title}>{file_docid ? "Document - " + file_docid : "Loading..."}</h2>
                        <button>{file_docid && <a download={"document_" + file_docid} title={"document_" + file_docid} href={"data:application/pdf;base64,"+file_base64}><img src={download_icon_white} alt="icon"/></a>}</button>
                    </div>
                    <div className={styles.pdf_viewer}>
                        <Document
                        onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                        file={{ data: atob(file_base64) }}
                        >
                            {Array.apply(null, Array(numPages))
                            .map((x, i)=>i+1)
                            .map(page => <div key={page} style={{marginBottom:"1.5rem"}}><Page pageNumber={page} renderAnnotationLayer={false}/></div>)}
                            
                        </Document>
                    </div>
                    <div className={styles.document_preview_bg} onClick={()=>{setviewPreview(false); setfile_base64("")}}></div>
                </div>
            }
            <div className={styles.title_header}>
                <button onClick={()=>{navigate("/Portaal/Dossiers"); docs_fast=[]; setdocuments([])}} className={styles.title_backButton}><img src={arrow_files_title} alt="icon"/></button>
                <button className={styles.title_previouslevel} onClick={()=>{navigate("/Portaal/Dossiers"); docs_fast=[]; setdocuments([])}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files && content_state[ReactSession.get("language")].Files.subtitle && content_state[ReactSession.get("language")].Files.subtitle) : "My files"}</button>
                <img className={styles.title_arrow} src={arrow_files_title} alt="arrow"/>
                <p className={styles.title_mainlevel}>{dossierTitle}</p>
            </div>

            <div>
                <div className={styles.file_header_buttons}>
                    {/* <div>
                        <button className={styles.header_button}><img src={download_icon_gray} alt="icon"/>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Files.tooltip_download_file && content_state[ReactSession.get("language")].Files.tooltip_download_file) : "Download files"}</button>
                    </div> */}
                </div>
                <div className={styles.file_table}>
                    <table className={styles.table}>
                        <tbody>
                            <tr className={styles.table_header}>
                                <th style={{width:"2rem"}}></th>
                                <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_files && content_state[ReactSession.get("language")].Dashboard.lastopened_table_files) : "File"}</th>
                                <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_type && content_state[ReactSession.get("language")].Dashboard.lastopened_table_type) : "Type"}</th>                              
                                <th style={{width:"9rem"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Dashboard.lastopened_table_date && content_state[ReactSession.get("language")].Dashboard.lastopened_table_date) : "Added on"}</th>
                                <th style={{width:"3rem"}}></th>
                            </tr>   
                            {docs &&
                            docs.map((v, i)=>{
                                if(v.document){
                                    return (
                                        <tr key={i}>
                                            <td id={v.docid} onClick={(e)=>{handleViewDocument(e, v)}} className={styles.dossier_icon}>
                                                <img src={pdf_icon} alt="pdf icon"/>
                                            </td>
                                            <td id={v.docid} onClick={(e)=>{handleViewDocument(e, v)}} className={styles.document_text}>
                                                <div>
                                                    <p>Document - {v.docid}</p>
                                                    <p className={styles.filetype_mobile}>{v.document && doctypeTranslations[v.document.doctype] && doctypeTranslations[v.document.doctype][ReactSession.get("language")]}</p>
                                                </div>
                                            </td>
                                            <td id={v.docid} onClick={(e)=>{handleViewDocument(e, v)}} className={styles.document_text_type}>{v.document && doctypeTranslations[v.document.doctype] && doctypeTranslations[v.document.doctype][ReactSession.get("language")]}</td>                       
                                            <td id={v.docid} onClick={(e)=>{handleViewDocument(e, v)}} className={styles.document_text_date}>{v.dateadded && new Date(v.dateadded).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })}</td>
                                            <td className={styles.table_downloadtag}><div id={v.docid} onClick={(e)=>{handleDownloadDocument(e)}} className={styles.download_button}><img src={download_icon_gray} alt="icon"/><span className={styles.tooltiptextAdmin}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Documents && content_state[ReactSession.get("language")].Documents.label_downloaddocument && content_state[ReactSession.get("language")].Documents.label_downloaddocument) : "Download document"}</span></div></td>
                                        </tr>
                                    )
                                }
                            })
                            }
                        </tbody>                   
                    </table>
                </div>
            </div>
            
	    </>  
  	);
}
 